<template>
  <b-container v-if="this.type" fluid>
    <h1>{{title || $appConfig.models[this.type].title}} <b-button variant="secondary" size="sm" v-b-modal.modalNewFixedPrice v-if="isHeadOperations" v-translate>+ NEW</b-button></h1>
    <b-card no-body class="filters">
      <b-tabs card v-model="tabIndex">
        <b-tab :title="$gettext('Quick Filters')" active>
          <b-card-text>
            <b-row>
              <b-col class="text-center filter-actions">
                <b-badge size="md" @click="resetQuickFilters" v-translate>Reset Filters</b-badge> <b-badge size="sm" @click="saveCurrentQuickFilters" v-translate>Save this Filters' Set</b-badge>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="1" md="4">
                <b-form-group>
                  <label v-translate>Fixed Prices for</label>
                  <b-form-radio-group v-model="filter.modelType" class="mb-3">
                    <b-form-radio :value="null"><translate>All</translate></b-form-radio>
                    <b-form-radio value="Api\Users\Models\User"><translate>User</translate></b-form-radio>
                    <b-form-radio value="Api\Companies\Models\Company"><translate>Company</translate></b-form-radio>
                  </b-form-radio-group>
                  <div v-show="filter.modelType === 'Api\\Companies\\Models\\Company'">
                    <label v-translate>Find Company</label>
                    <company-autocomplete ref="companyAc" @selected="onAccountSearchCompanySelected" :includes="['account']" />
                    <span v-if="filter.modelId.length > 0">
                      <span v-translate="{data: filter.modelId[0].name}">Company: <strong>%{data}</strong></span><br>
                      <span v-translate="{data: filter.modelId[0].id}">Company ID: <strong>%{data}</strong></span> <span class="text-success">✔</span>
                    </span>
                  </div>
                  <div v-show="filter.modelType === 'Api\\Users\\Models\\User'">
                    <label v-translate>Find User</label>
                    <user-autocomplete ref="userAc" @selected="onAccountSearchUserSelected" :includes="['account']" with-picture />
                    <span v-if="filter.modelId.length > 0">
                      <span v-translate="{data: filter.modelId[0].name}">User: <strong>%{data}</strong></span><br>
                      <span v-translate="{data: filter.modelId[0].id}">User ID: <strong>%{data}</strong></span> <span class="text-success">✔</span>
                    </span>
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group>
                  <label v-translate>Type</label>
                  <b-form-radio-group v-model="filter.type">
                    <b-form-radio :value="null"><translate>All</translate></b-form-radio>
                    <b-form-radio value="tour"><translate>Tour</translate></b-form-radio>
                    <b-form-radio value="time">Time</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group>
                  <label class="" for="inline-form-input-name" v-translate>Start Date Range </label><label v-show="filter.fromDateRangeActive !== 0">&nbsp;[<a href="#" @click.prevent="resetFromDateRange" v-translate>reset range</a>]</label>
                  <date-range-picker
                    v-if="datepickerLocalized"
                    v-model="fromDateRange"
                    @update="filter.fromDateRangeActive++"
                    :locale-data="{...locale}"
                    :opens="opens"
                    class="mb-2 w-100"
                    :ranges="ranges"
                  >
                    <div slot="input" slot-scope="picker">
                      <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
                      <span v-if="filter.fromDateRangeActive === 0" style="vertical-align: middle">...</span>
                      <span v-else style="vertical-align: middle">{{moment(fromDateRange.startDate).format('L')}} - {{moment(fromDateRange.endDate).format('L')}}</span>
                    </div>
                  </date-range-picker>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group>
                  <label v-translate>Status</label>
                  <b-form-radio-group v-model="filter.status">
                    <b-form-radio :value="null"><translate>All</translate></b-form-radio>
                    <b-form-radio value="pending"><translate>Pending</translate></b-form-radio>
                    <b-form-radio value="proccesed"><translate>Proccessed</translate></b-form-radio>
                    <b-form-radio value="error"><translate>Error</translate></b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group>
                  <label class="" for="inline-form-input-name" v-translate>End Date Range </label><label v-show="filter.toDateRangeActive !== 0">&nbsp;[<a href="#" @click.prevent="resetToDateRange" v-translate>reset range</a>]</label>
                  <date-range-picker
                    v-if="datepickerLocalized"
                    v-model="toDateRange"
                    @update="filter.toDateRangeActive++"
                    :locale-data="{...locale}"
                    :opens="opens"
                    class="mb-2 w-100"
                    :ranges="ranges"
                  >
                    <div slot="input" slot-scope="picker">
                      <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
                      <span v-if="filter.toDateRangeActive === 0" style="vertical-align: middle">...</span>
                      <span v-else style="vertical-align: middle">{{moment(toDateRange.startDate).format('L')}} - {{moment(toDateRange.endDate).format('L')}}</span>
                    </div>
                  </date-range-picker>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-text>
        </b-tab>
        <b-tab :title="$gettext('Advanced Filters')">
          <b-card-text>
            <b-row>
              <b-col lg="12" class="my-1">
                <listing-filter :type="type" @save-filter="saveCurrentAdvancedFilters" :filter-fields="filterFields" :pre-filters="preFilters" @refresh="refreshTable" ref="listingFilters" />
              </b-col>
            </b-row>
          </b-card-text>
        </b-tab>
        <b-tab :title="$gettext('Saved Filters')" :disabled="savedFixedPricesQuickSearches.length === 0">
          <b-list-group>
            <b-list-group-item v-for="(savedQuickSearch, index) in savedFixedPricesQuickSearches" :key="index" :href="savedQuickSearch.url" class="d-flex justify-content-between align-items-center">
              {{ savedQuickSearch.name }}
              <b-badge href="#" @click.stop.prevent="deleteSavedQuickSearch(index)" variant="danger">✕</b-badge>
            </b-list-group-item>
          </b-list-group>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-row class="mb-3">
      <b-col>

      </b-col>
      <b-col cols="12" sm="3" lg="2">
        <b-form-group horizontal :label="$gettext('Per page')" :label-cols="6" class="text-right mb-0">
          <b-form-select  cols="6" :options="pageOptions" v-model="perPage" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="bg-white py-1" v-translate="{totalRows: totalRows || '-'}">
        Total items: <strong>%{totalRows}</strong>
      </b-col>
    </b-row>
    <b-table id="my-table" stacked="md" foot-clone :total-rows="totalRows" :sort-desc="sortDesc" :sort-by="sortBy" :per-page="perPage" :current-page="currentPage" :busy.sync="isBusy" :items="myProvider" :fields="fields" :api-url="this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint" :filter="applyFilter">

      <div slot="table-busy" class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong v-translate>Loading...</strong>
      </div>

      <template v-slot:cell(id)="data">
        {{data.value | uuid }} <a href="#" @click.prevent="copyToClipboard(data.value)" class="text-secondary" :title="$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
      </template>

      <template v-slot:cell(profile_picture)="row">
        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" class="rounded" v-b-tooltip.html
        :title="'<img src=data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII= style=\'background: transparent url(' + (row.item.profile_picture || 'https://www.gravatar.com/avatar/default?s=150&r=pg&d=mm') + ') no-repeat 50% 50%/cover;\' width=150 height=150 />'" :style="'display: inline-block; width: 50px; height: 50px; background: transparent url(' + (row.item.profile_picture || 'https://www.gravatar.com/avatar/default?s=50&r=pg&d=mm') + ') no-repeat 50% 50%/cover;'" alt="Avatar" />
      </template>

      <template v-slot:cell(type)="row">
        <b-badge :variant="row.value === 'tour' ? 'secondary' : 'primary'" style="text-transform: uppercase">{{row.value}}</b-badge>
        <div v-if="row.value === 'tour'" style="white-space: nowrap">
          <strong v-translate>Tour ID:</strong>
          <a :href="'/edit/tours/' + row.item.fixed_tour.tour_id" target="_blank">{{row.item.fixed_tour.tour_id | uuid }}</a>
          <a href="#" @click.prevent="copyToClipboard(row.item.fixed_tour.tour_id)" class="text-secondary" :title="$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
        </div>
      </template>

      <template v-slot:cell(amount)="row">
        {{row.item.amount}} {{row.item.currency}}
        <div v-if="row.item.type === 'tour'">
          <span v-translate="{hours: row.item.fixed_tour.fixed_hours}"><abbr title="Estimated">Est.</abbr> Hours: %{hours}</span><br>
          <span v-translate="{maxExtraHours: row.item.fixed_tour.max_extra_hours, price: row.item.fixed_tour.extra_hour_price}"><abbr title="Maximum Extra Hours">M.E.H.</abbr>: %{maxExtraHours} <small>(%{price}/Hour)</small></span>
        </div>
      </template>

      <template v-slot:cell(model_id)="row">
        <span v-if="row.item.model_type.indexOf('User') !== -1">
          <user-card :user='row.item.fixed_tour ? row.item.fixed_tour.tour.courier : row.item.owner' :profile-picture="false" :with-titles="false" :with-map="false" :vehicle-types-prop="vehicleTypes" />
        </span>
        <div v-else class="company-card__profile-data">
          <h5><a target="_blank" :href="'/edit/companies/' + row.item.owner.id">#{{row.item.owner.id}}</a>
          {{row.item.owner.name}} <small>({{row.item.owner.business_name}})</small></h5>
          <p>{{row.item.owner.contact_name}} (<a :href="'mailto:' + row.item.owner.email">{{row.item.owner.email}}</a>)<br>
          {{row.item.owner.phone | phone(row.item.owner.country_iso_code)}}</p>
        </div>
      </template>

      <template v-slot:cell(from_date)="row">
        {{moment.utc(row.value).tz($tz).format('L LT')}}
        <small v-if="row.item.type === 'tour'">
          (<abbr :title="$gettext('Estimated')" v-translate>Est.</abbr>)
        </small>
      </template>

      <template v-slot:cell(to_date)="row">
        {{moment.utc(row.value).tz($tz).format('L LT')}}
        <small v-if="row.item.type === 'tour'">
          (<abbr :title="$gettext('Estimated')" v-translate>Est.</abbr>)
        </small>
      </template>

      <template v-slot:cell(status)="row" class="text-center">
        <b-badge pill :title="$options.filters.capitalize(row.value)" :variant="row.item.status === 'pending' ? 'dark' : (row.item.status === 'canceled' || row.item.status === 'reverted' ? 'danger' : 'success')">{{row.value | capitalize}}</b-badge>
      </template>

      <template v-slot:cell(free)="row">
        <span :title="row.item.courier_available && row.item.courier_available.tracking.length > 0 ? (!row.item.courier_available.tracking[0].shipping_id ? 'FREE' : 'BUSY') : 'OFFLINE'" style="display: inline-block; width:15px; height:15px; border-radius: 100px;" :class="row.item.courier_available && row.item.courier_available.tracking.length > 0 ? (!row.item.courier_available.tracking[0].shipping_id ? 'bg-success' : 'bg-danger') : 'bg-dark'"></span>
      </template>

      <template v-slot:cell(proccessed_data)="row">
        <div v-if="row.item.fixed_tour">
          <div v-if="row.item.fixed_tour.tour.started_at" v-translate="{data: moment.utc(row.item.fixed_tour.tour.started_at).tz($tz).format('L LT')}">
            Started <small>(Real)</small>: %{data}
          </div>
          <div v-if="row.item.fixed_tour.tour.finished_at" v-translate="{data: moment.utc(row.item.fixed_tour.tour.finished_at).tz($tz).format('L LT')}">
            Ended <small>(Real)</small>: %{data}
          </div>
          <div v-if="row.item.fixed_tour.tour.started_at && row.item.fixed_tour.tour.finished_at"
            :class="(row.item.fixed_tour.fixed_hours + row.item.fixed_tour.max_extra_hours) < moment.duration(moment(row.item.fixed_tour.tour.finished_at).diff(moment(row.item.fixed_tour.tour.started_at))).asHours() ? 'text-danger' : 'text-success'"
             v-translate="{data: elapsedTime(row.item.fixed_tour.tour.started_at, row.item.fixed_tour.tour.finished_at)}"
          >
            Took <small>(Real)</small>: %{data}
          </div>
        </div>
      </template>

      <template v-slot:cell(result)="row">
        <div v-if="row.item.fixed_tour && row.item.fixed_tour.tour.finished_at && row.item.fixed_tour.tour.account_transactions.length > 0" v-html="processedDataResult(row.item.fixed_tour.tour)"></div>
      </template>

      <template v-slot:cell(actions)="row">
        <b-button pill size="sm" @click.stop="row.toggleDetails" style="padding: .5rem">
          <font-awesome-icon v-if="row.detailsShowing" :icon="['far', 'eye-slash']" size="2x" style="font-size: 16px;vertical-align: middle" />
          <font-awesome-icon v-else :icon="['far', 'eye']" size="2x" style="font-size: 16px;vertical-align: middle" />
        </b-button>
        <b-button pill size="sm" v-b-modal.modalEditFixedPrice @click="fixedPriceToEdit = row.item" style="padding: .5rem .55rem" v-if="row.item.status === 'pending'">
          <font-awesome-icon :icon="['fa', 'pencil-alt']" size="2x" style="font-size: 16px;vertical-align: middle" />
        </b-button>
        <b-button pill size="sm" variant="danger" @click.stop="revertFixedPrice(row.item.id)" style="padding: .5rem .65rem" v-if="row.item.status !== 'canceled' && row.item.status !== 'reverted'">
          <font-awesome-icon icon="trash-alt" size="2x" style="font-size: 16px;vertical-align: middle" />
        </b-button>
      </template>

      <template v-slot:row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key" v-if="value && value.length !== 0 && value !== 'undefined' && value !== null">{{ key }}: <span v-html="key.indexOf('phone') === -1 ? isJson(value) : value.toString()"></span></li>
          </ul>
        </b-card>
      </template>

    </b-table>
    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />

    <b-modal id="modalNewFixedPrice" ref="modalNewFixedPrice" hide-footer>
      <div slot="modal-title" v-translate>New Fixed Price for Couriers</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <fixed-price-form multi-users @success="refreshTable(); $refs.modalNewFixedPrice.hide()" @cancel="$refs.modalNewFixedPrice.hide()" />
    </b-modal>

    <b-modal id="modalEditFixedPrice" ref="modalEditFixedPrice" hide-footer @hide="fixedPriceToEdit = null">
      <div slot="modal-title" v-translate>Edit Fixed Price</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <fixed-price-form :item="fixedPriceToEdit" :user="fixedPriceToEdit.model_type === 'Api\\Users\\Models\\User' ? fixedPriceToEdit.owner : null" :company="fixedPriceToEdit.model_type === 'Api\\Companies\\Models\\Company' ? fixedPriceToEdit.owner : null" @success="refreshTable(); $refs.modalEditFixedPrice.hide()" @cancel="$refs.modalEditFixedPrice.hide()" />
    </b-modal>
  </b-container>
</template>

<script>
function initialQuickFilters() {
  return {
    modelType: null,
    modelId: [],
    type: null,
    status: null,
    fromDateRangeActive: 0,
    toDateRangeActive: 0
  }
}
import ListingFilter from '@/components/ListingFilter'
import UserCard from '@/components/UserCard'
import DateRangePicker from 'vue2-daterange-picker'
import FixedPriceForm from '@/components/FixedPriceForm'
import CompanyAutocomplete from '@/components/autocompletes/CompanyAutocomplete'
import UserAutocomplete from '@/components/autocompletes/UserAutocomplete'

export default {
  name: 'ApiList',
  components: {
    ListingFilter,
    UserCard,
    DateRangePicker,
    FixedPriceForm,
    CompanyAutocomplete,
    UserAutocomplete
  },
  props: {
    type: {
      type: String,
      default: 'fixed-prices'
    },
    title: {
      type: String
    },
    preFilters: {
      type: Array,
      default: () => {
        return []
      }
    },
    prePerPage: {
      type: Number,
      default: 25
    }
  },
  data () {
    return {
      tabIndex: 0,
      fields: [],
      filterFields: this.$appConfig.models[this.type].filters,
      exclude: this.$appConfig.models[this.type].exclude,
      includes: this.$appConfig.models[this.type].includes || [],
      isBusy: false,
      currentPage: 1,
      perPage: this.prePerPage,
      totalRows: null,
      pageOptions: [ 10, 25, 50, 100, 500 ],
      sortBy: 'updated_at',
      sortDesc: true,
      sortDirection: 'desc',
      filters: this.preFilters,
      filter: initialQuickFilters(),
      quickFilters: {},
      savedFixedPricesQuickSearches: [],
      companyAcOptions: {
        debounce: 500,
        placeholder: this.$gettext('Company Name, Business Name or TIN'),
        inputClass: 'form-control'
      },
      searchCompanyQuery: '',
      userAcOptions: {
        debounce: 500,
        placeholder: this.$gettext('User Name or Email'),
        inputClass: 'form-control'
      },
      searchUserQuery: '',
      minCharacter: 2,
      fromDateRange: {
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate()
      },
      toDateRange: {
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate()
      },
      opens: 'right',
      locale: {},
      ranges: {
        [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
        [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(1, 'days').toDate()],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('This month')]: [this.moment().startOf('month').toDate(), this.moment().endOf('month').toDate()],
        [this.$gettext('This year')]: [this.moment().startOf('year').toDate(), this.moment().endOf('year').toDate()],
        [this.$gettext('Last week')]: [this.moment().subtract(1, 'week').startOf('week').toDate(), this.moment().subtract(1, 'week').endOf('week').toDate()],
        [this.$gettext('Last month')]: [this.moment().subtract(1, 'month').startOf('month').toDate(), this.moment().subtract(1, 'month').endOf('month').toDate()]
      },
      datepickerLocalized: false,
      dismissSecs: 5,
      dismissCountDown: 0,
      fixedPriceToEdit: {}
    }
  },
  watch: {
    type: function (val) {
      console.log(this.type)
      console.log(val)
      this.resetData()
      this.$refs.listingFilters.resetData()
      this.fields = this.$appConfig.models[this.type].fields
      this.filterFields = this.$appConfig.models[this.type].filters
      this.exclude = this.$appConfig.models[this.type].exclude
      this.fields.push({ key: 'proccessed_data', label: this.$gettext('Proccessed Data') })
      this.fields.push({ key: 'actions', label: this.$gettext('Actions') })
      let that = this
      this.fields = this.fields.filter(function (obj) {
        if (that.exclude) {
          return that.exclude.indexOf(obj.key) === -1
        } else {
          return true
        }
      })
      this.refreshTable()
    },
    exclude: function (val) {
      return this.$appConfig.models[this.type].exclude
    },
    'filter.modelType': {
      handler (val) {
        this.filter.modelId = []
        if (val) {
          this.quickFilters['modelType'] = [ 'model_type', 'eq', val ]
        } else {
          this.quickFilters['modelType'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.modelId': {
      handler (val) {
        if (val.length > 0) {
          let owner = val.map(function (item) {
            return item.id
          })
          let ownerNames = val.map(function (item) {
            return item.name
          })
          this.quickFilters['modelId'] = [[ 'model_id', 'in', owner ], ownerNames]
        } else {
          this.quickFilters['modelId'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.type': {
      handler (val) {
        if (val) {
          this.quickFilters['type'] = [ 'type', 'eq', val ]
        } else {
          this.quickFilters['type'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.status': {
      handler (val) {
        if (val) {
          this.quickFilters['status'] = [ 'status', 'eq', val ]
        } else {
          this.quickFilters['status'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.fromDateRangeActive': {
      handler (val) {
        if (val !== 0) {
          this.quickFilters['fromDateFrom'] = ['from_date', 'gte', this.fromDateRange.startDate.length === 19 ? this.moment(this.fromDateRange.startDate).utc().format('YYYY-MM-DD HH:mm:ss') : this.moment(this.fromDateRange.startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]
          this.quickFilters['fromDateTo'] = ['from_date', 'lte', this.fromDateRange.endDate.length === 19 ? this.moment(this.fromDateRange.endDate).utc().format('YYYY-MM-DD HH:mm:ss') : this.moment(this.fromDateRange.endDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]
        } else {
          this.quickFilters['fromDateFrom'] = []
          this.quickFilters['fromDateTo'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.toDateRangeActive': {
      handler (val) {
        if (val !== 0) {
          this.quickFilters['toDateFrom'] = ['to_date', 'gte', this.toDateRange.startDate.length === 19 ? this.moment(this.toDateRange.startDate).utc().format('YYYY-MM-DD HH:mm:ss') : this.moment(this.toDateRange.startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]
          this.quickFilters['toDateTo'] = ['to_date', 'lte', this.toDateRange.endDate.length === 19 ? this.moment(this.toDateRange.endDate).utc().format('YYYY-MM-DD HH:mm:ss') : this.moment(this.toDateRange.endDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]
        } else {
          this.quickFilters['toDateFrom'] = []
          this.quickFilters['toDateTo'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    }
  },
  computed: {
    applyFilter () {
      return this.filter
    }
  },
  created() {
    this.fetchVehicleTypes()
    window.addEventListener('popstate', () => {
      if (this.$route.query.s) {
        this.tabIndex = 1
        this.checkAdvancedFilters()
      } else if (this.$route.query.qs) {
        this.tabIndex = 0
        this.checkQuickFilters()
      }
    })
  },
  mounted() {
    if (this.$route.query.created === true) {
      this.showAlert()
    }
    this.resetData()
    this.fields = this.$appConfig.models[this.type].fields
    this.includes = this.$appConfig.models[this.type].includes
    this.exclude = this.$appConfig.models[this.type].exclude
    let that = this
    let fields = this.fields.filter(function (obj) {
      if (that.exclude) {
        return that.exclude.indexOf(obj.key) === -1
      } else {
        return true
      }
    })
    fields.push({ key: 'proccessed_data', label: this.$gettext('Proccessed Data') })
    fields.push({ key: 'result', label: this.$gettext('Result') })
    fields.push({ key: 'actions', label: this.$gettext('Actions') })
    this.fields = fields
    if (this.$route.query.s) {
      this.tabIndex = 1
      this.checkAdvancedFilters()
    } else if (this.$route.query.qs) {
      this.checkQuickFilters()
    } else {
      this.refreshTable()
    }
    if (localStorage.savedFixedPricesQuickSearches) {
      this.savedFixedPricesQuickSearches = JSON.parse(localStorage.savedFixedPricesQuickSearches)
    }
    this.initDatePicker()
  },
  methods: {
    initDatePicker() {
      this.locale = {
        direction: 'ltr', //  direction of text
        format: 'dd/mm/yyyy', //  fomart of the dates displayed
        separator: ' - ', //  separator between the two ranges
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: this.$gettext('Custom Range'),
        daysOfWeek: this.moment.weekdaysMin(), // days, //  array of days - see moment documenations for details
        monthNames: this.moment.monthsShort(), //  array of month names - see moment documenations for details
        firstDay: 1,
        showWeekNumbers: false //  show week numbers on each row of the calendar
      }
      this.ranges = {
        [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
        [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(1, 'days').toDate()],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('This month')]: [this.moment().startOf('month').toDate(), this.moment().endOf('month').toDate()],
        [this.$gettext('This year')]: [this.moment().startOf('year').toDate(), this.moment().endOf('year').toDate()],
        [this.$gettext('Last week')]: [this.moment().subtract(1, 'week').startOf('week').toDate(), this.moment().subtract(1, 'week').endOf('week').toDate()],
        [this.$gettext('Last month')]: [this.moment().subtract(1, 'month').startOf('month').toDate(), this.moment().subtract(1, 'month').endOf('month').toDate()]
      }
      this.datepickerLocalized = true
    },
    onAccountSearchCompanySelected(item) {
      this.filter.modelId.push({id: item.id, name: item.name})
      this.$refs.companyAc.searchQuery = ''
    },
    removeCompanyFromFilters(index) {
      this.filter.modelId.splice(index, 1)
    },
    onAccountSearchUserSelected(item) {
      this.filter.modelId.push({id: item.id, name: item.name})
      this.$refs.userAc.searchQuery = ''
    },
    resetFromDateRange() {
      this.fromDateRange = {
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate()
      }
      this.filter.fromDateRangeActive = 0
    },
    resetToDateRange() {
      this.toDateRange = {
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate()
      }
      this.filter.toDateRangeActive = 0
    },
    checkAdvancedFilters() {
      // this.quickFilters = []
      if (this.$route.query.s) {
        this.advancedFilters = JSON.parse(this.$route.query.s)
        this.$refs.listingFilters.filters = this.advancedFilters
        console.log(this.advancedFilters)
      }
      this.refreshTable(this.advancedFilters)
    },
    checkQuickFilters() {
      this.advancedFilters = []
      this.$refs.listingFilters.resetData()
      if (this.$route.query.qs) {
        this.quickFilters = JSON.parse(this.$route.query.qs)
        Object.keys(JSON.parse(this.$route.query.qs)).forEach(function (key) {
          if (this.quickFilters[key].length > 2) {
            if (key === 'createdAtFrom') {
              this.fromDateRange.startDate = this.quickFilters[key][2]
            }
            if (key === 'createdAtTo') {
              this.fromDateRange.endDate = this.quickFilters[key][2]
              this.filter.fromDateRangeActive = true
            }

            this.filter[key] = this.quickFilters[key][2]
          } else if (this.quickFilters[key].length === 2) {
            this.filter[key] = []
            for (let i = 0; i < this.quickFilters[key][0][2].length; i++) {
              this.filter[key].push({id: this.quickFilters[key][0][2][i], name: this.quickFilters[key][1][i], email: this.quickFilters[key][1][i]})
            }
          }
        }.bind(this))
        this.updateQuickFilters()
      }
    },
    updateQuickFilters() {
      if (this.tabIndex === 0) {
        this.currentPage = 1
        let filters = []
        Object.values(this.quickFilters).forEach(function (filter) {
          if (filter.length === 2) {
            filters.push(filter[0])
          } else {
            filters.push(filter)
          }
        })
        if (filters.length > 0) {
          this.$router.push({ query: {qs: this.localizeDates(JSON.stringify(this.quickFilters))} })
        }
        this.refreshTable(filters)
      }
    },
    resetQuickFilters: function () {
      Object.assign(this.$data.filter, initialQuickFilters())
      this.updateQuickFilters()
    },
    saveCurrentQuickFilters() {
      let name = prompt(this.$gettext('Please set a name for this Filters Set'))
      if (name) {
        this.savedFixedPricesQuickSearches.push({name: 'QUICK: ' + name, url: window.location.href})
      } else {
        alert(this.$gettext('You must write a name for this Filters Set'))
      }
      try {
        localStorage.savedFixedPricesQuickSearches = JSON.stringify(this.savedFixedPricesQuickSearches)
      } catch (e) {
        alert(this.$gettext('The Filters couldn\'t be saved'))
      }
      this.savedFixedPricesQuickSearches = JSON.parse(localStorage.savedFixedPricesQuickSearches)
    },
    resetAdvancedFilters: function () {
      this.$refs.listingFilters.resetData()
      this.$refs.listingFilters.emitRefresh()
    },
    saveCurrentAdvancedFilters() {
      let name = prompt(this.$gettext('Please set a name for this Filters Set'))
      if (name) {
        this.savedFixedPricesQuickSearches.push({name: 'ADVANCED: ' + name, url: window.location.href})
      } else {
        alert(this.$gettext('You must write a name for this Filters Set'))
      }
      try {
        localStorage.savedFixedPricesQuickSearches = JSON.stringify(this.savedFixedPricesQuickSearches)
      } catch (e) {
        alert(this.$gettext('The Filters couldn\'t be saved'))
      }
      this.savedFixedPricesQuickSearches = JSON.parse(localStorage.savedFixedPricesQuickSearches)
    },
    deleteSavedQuickSearch(index) {
      this.savedFixedPricesQuickSearches.splice(index, 1)
      localStorage.savedFixedPricesQuickSearches = JSON.stringify(this.savedFixedPricesQuickSearches)
      this.savedFixedPricesQuickSearches = JSON.parse(localStorage.savedFixedPricesQuickSearches)
    },
    myProvider (ctx) {
      console.log(ctx)
      let params = {
        page: ctx.currentPage - 1,
        limit: ctx.perPage,
        includes: this.includes,
        sort: [
          {
            key: ctx.sortBy || 'id',
            direction: ctx.sortDesc ? 'desc' : 'asc'
          }
        ]
      }
      console.log(this.filters)
      // this.filters.push(['roles.name', 'ct', this.$roles.COURIER])
      if (this.filters || this.preFilters) {
        params.filter_groups = [
          {
            filters: this.filters || this.preFilters
          }
        ]
      }
      console.log(JSON.stringify(params))

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['owner_country', 'eq', window.country]
            ]
          }
        )
      }

      let promise = this.$http.get(ctx.apiUrl, { params: params })

      return promise.then((data) => {
        const items = data.body.data
        this.totalRows = data.body.pagination.total
        return (items)
      }).catch(error => {
        console.log(error)
        return []
      })
    },
    refreshTable (filters) {
      console.log(filters)
      this.filters = filters
      setTimeout(() => {
        this.$root.$emit('bv::refresh::table', 'my-table')
      }, 100)
    },
    resetData: function () {
      Object.assign(this.$data, this.$options.data.call(this))
    },
    processedDataResult(tour) {
      const courierCredits = tour.account_transactions.filter(x => x.relationship === 'provider' && x.type === 'credit')
        .map(x => parseFloat(x.amount))
        .reduce((total, num) => total + num, 0)

      const courierDebits = tour.account_transactions.filter(x => x.relationship === 'provider' && x.type === 'debit')
        .map(x => parseFloat(x.amount))
        .reduce((total, num) => total + num, 0)

      const courierProfit = (Math.round(((courierCredits - courierDebits) + Number.EPSILON) * 100) / 100).toFixed(2)

      const clientCredits = tour.account_transactions.filter(x => x.relationship === 'client' && x.type === 'credit')
        .map(x => parseFloat(x.amount))
        .reduce((total, num) => total + num, 0)

      const clientDebits = tour.account_transactions.filter(x => x.relationship === 'client' && x.type === 'debit')
        .map(x => parseFloat(x.amount))
        .reduce((total, num) => total + num, 0)

      const clientCost = (Math.round(((clientDebits - clientCredits) + Number.EPSILON) * 100) / 100).toFixed(2)

      const ourProfit = (Math.round(((clientCost - courierProfit) + Number.EPSILON) * 100) / 100).toFixed(2)

      const take = (Math.round(((ourProfit * 100 / clientCost) + Number.EPSILON) * 100) / 100).toFixed(2)

      let html = '<span style="white-space: nowrap">' +
        this.$gettextInterpolate(this.$gettext('Courier profit: %{data}'), {data: courierProfit + ' ' + tour.account_transactions[0].currency}) + '</span><br>' +
        '<span style="white-space: nowrap">' +
        this.$gettextInterpolate(this.$gettext('Client cost: %{data}'), {data: clientCost + ' ' + tour.account_transactions[0].currency}) + '</span><br>' +
        '<span class="' + (take >= 30 ? 'text-success' : (take < 30 && take > 0 ? 'text-warning' : 'text-danger')) + '">' +
        this.$gettextInterpolate(this.$gettext('Our profit: %{data}'), {data: ourProfit + ' ' + tour.account_transactions[0].currency}) + '</span><br>' +
        '<span class="' + (take >= 30 ? 'text-success' : (take < 30 && take > 0 ? 'text-warning' : 'text-danger')) + '">' +
        this.$gettextInterpolate(this.$gettext('Take: %{data}'), {data: take}) + '</span>'

      return html
    },
    revertFixedPrice(id) {
      if (
        confirm(this.$gettext('Are you sure you want to REVERT/REVOQUE this Fixed Price\nWARNING: THIS ACTION CANNOT BE UNDONE!'))
      ) {
        this.$http.post(this.$appConfig.api.baseUrl + 'fixed-amount-price-schedules/' + id + '/revert')
          .then(response => {
            this.refreshTable(this.filters)
          })
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>

<style lang="scss">
.company-card__profile-data {
  h5 {
    font-weight: 400;
    white-space: nowrap;
    margin-bottom: 0;
  }
}
</style>
